<template>
  <SmartHrLocalList module-type="GROWTH" title="新人成长" group-name="员工关系"/>
</template>
<script>
import SmartHrLocalList from './SmartHrLocalList'
export default {
  name: 'SmartHrGrowth',
  components: { SmartHrLocalList }
}
</script>



// WEBPACK FOOTER //
// SmartHrGrowth.vue?1a8aa361